import {
  Box,
} from "@chakra-ui/react";
import ImpactBlock from "./impactblock";
import LineSection from "../lineSection";

export default function Impact() {
  return (
    <>
      <LineSection />

      <Box
        color='white'
        bg="black"
        py={{base:20,md:20, xl:40}}
      >

        <ImpactBlock
          image="img/double-exposure-man-signing-contract-with-phone-social-network-icon-hologram-concept-international-business-data-information.webp"
          title="Short time impact"
          text1="Close the educational and economic gap faced by young people from marginalized communities, helping them achieve the necessary training to become creators and leaders in technology."
        />
        <Box 
          h={"60px"}
          display={{base:"flex",md:"none",xl:"none"}}
        ></Box>
        <ImpactBlock
          image="img/analyst-team-utilizing-bi-fintech-analyze-financial-data-table-prudent.webp"
          title="Long time Impact"
          text1="We envision a world where young people who were once marginalized due to their social conditions, become leaders in the technology industry, contributing to innovation and positive change in their communities."
          text2="In the long term, we hope our benefited will become mentors and advocates for education, further extending the impact of our initiative."
        />

      </Box>
    </>
  );
}